// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".id--requirements ul[data-v-6e4cc218]{list-style:disc;padding-left:2em}.id--requirements li[data-v-6e4cc218]{margin-bottom:.5em}form .form-group label.control-label[data-v-6e4cc218]{display:flex;align-items:center;justify-content:flex-end}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
